'use strict';

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { ContextMenu, TipBinder } from './Dialogs';
import { HAComponent } from './Generic';

class Loading extends React.PureComponent {
	static version = '0.1.0';
	static propTypes = {
		size: PropTypes.string,
		theme: PropTypes.string,
	};
	static defaultProps = {
		size: null,
	};
	static height = {
		md: 100,
		lg: 150,
		'2x': 200,
		'3x': 300,
	};

	render() {
		const {size, children, theme, style, className} = this.props;
		const cssClass = `loading ${size ? `loading-${size}` : ''} ${theme ? theme : ''}`;
		const _style = {
			marginRight: 5,
			marginLeft: 5,
			... size ? {
				height: Loading.height[size],
				position: 'relative',
			} : null,
			... style,
		};
		return size ? <div {...{style: _style, className}}>
			<span className={cssClass}>{children}</span>
		</div> : <span className={cssClass} style={_style}>{children}</span>;
	}
}

class Switcher extends React.PureComponent{
	static propTypes = {
		enable: PropTypes.bool,
		onText: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
			PropTypes.element
		]),
		offText: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
			PropTypes.element
		]),
		onUpdate: PropTypes.func,
		value: PropTypes.number,
		id: PropTypes.number.isRequired,
		api: PropTypes.string.isRequired,
	};
	static defaultProps = {
		enable: true
	};
	state = {
		value: null,
		enable: this.props.enable,
		switching: false,
	};

	constructor(props){
		super(props);
	}

	static getDerivedStateFromProps(props, state) {
		const {value} = props;
		if(_.isNil(value) || state.value == value) return null;
		else if(state.value === null){
			state.value = value == true;
			return state;
		}
		else return null;
	}

	shouldComponentUpdate(nextProps, nextState){
		return nextState.value != this.state.value || nextState.switching != this.state.switching;
	}

	_switching(turn){
		const {switching, value} = this.state;
		if(switching || value === (turn == 'on' ? 1 : 0)) return;

		const {id, api, onUpdate} = this.props;
		new Ajax({
			url: `${api}/${turn == 'on' ? 'on' : 'off'}/${id}`,
			method: 'get',
			onRequest: () => this.setState({switching: true}),
			onSuccess: (code, msg, data, xhr) =>{
				this.setState({switching: false, value: turn == 'on' ? 1 : 0});
				if(onUpdate) onUpdate(turn == 'on' ? 1 : 0);
			},
			onError: (code, msg, data, xhr) => this.setState({switching: false}),
		}).send();
	}

	render(){
		const {onText, offText, onUpdate} = this.props;
		const {value, enable, switching} = this.state;

		const _switch = evt => {
			if(!enable || switching) return;
			this._switching(value ? 'off' : 'on');
		};
		const _turnOn = evt => {
			if(!enable || value || switching) return;
			this._switching('on');
		};
		const _turnOff = evt => {
			if(!enable || !value || switching) return;
			this._switching('off');
		};
		return <span className={`H2-Switch${value ? ' on' : ''}${(enable && !switching) ? '' : ' disable'}`}>
			{offText ? <span className={'-off'} onClick={_turnOff}>{offText}</span> : null}
			{switching ? <span className={'loading inlineBlock'} style={{margin:'7px 8px 8px 8px'}} /> : <span className={'-switcher'} onClick={_switch}/>}
			{onText ? <span className={'-on'} onClick={_turnOn}>{onText}</span> : null}
		</span>;
	}
}

const _button = (props, ico, text) => {
	const {theme, type, className, style, disable, onClick, children, loading} = props;
	const icoStr = ico ? `fa fa-${ico}` : '';
	return props.auth !== false && <div {...{
		className: `btn btn-${theme || type || 'default'} ${className || ''}${disable || loading ? ' disabled' : ''} ${icoStr}`,
		... style ? {style} : null,
		... disable ? {disabled: 'disabled'} : null,
		... !disable && !loading && onClick ? {onClick} : null,
	}}>{loading ? <Loading /> : null} {children || text}</div>;
};
const Button = {
	New: props => _button({... props, theme: 'success'}, 'plus', '新增'),
	BatchNew: props => _button({... props, theme: 'success'}, 'folder-plus', '批次新增'),
	Arrange: props => _button(props, 'sort-alt', '排序設定'),
	Import: props => _button(props, 'file-import', OptionUtils.getLabel('hp.m5.m510010.wf021_row', 'importIn')),
	Export: props => _button(props, 'file-export', OptionUtils.getLabel('global.normal', 'export')),
	Report: props => _button(props, 'file-chart-line', '報表'),
	Check: props => _button(props, 'clipboard-check', '檢查'),
	Trash: props => _button({... props, theme: 'danger'}, 'trash-alt', '刪除'),
	Normal: ({ ico, text, ...props }) => _button(props, ico, text),
	Ok: props => _button({ ...props, theme: 'primary' }, 'check',
		OptionUtils.getLabel('global.normal', 'sure')),

	// 可以的話不要用Button.One 用Button.Normal取代
	One: props => props.auth !== false && <span {...{
		ref: props.refx,
		className: `btn btn-${props.type || 'default'} ${props.className || ''} ${props.disable ? ' disabled' : ''}`,
		onClick: props.disable ? void 0 : props.onClick,
		style: props.style,
		[props.disable ? 'disable' : 'enable']: 'disabled',		// 這裡怪怪的 應該有問題
	}}>{props.ico ? <i className={`fal fa-${props.ico}`} /> : ''} {props.children}</span>,
};

class GroupButton extends HAComponent {
	static version = '0.1.0';
	static propTypes = {
		align: PropTypes.oneOf(['left', 'right']),
		pointer: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom', 'left', 'right'])]),
	};
	static defaultProps = {
		domInst: 'span',
		align: 'left',
		pointer: 'top',
		disable: false,
	};
	state = {
		press: false,
	};

	render() {
		const { domInst: DOMInst, buttons, align, className, styles, children, pointer, auth, disable } = this.props;
		if (auth === false) return '';

		const { press } = this.state;
		return <DOMInst {...{
			ref: ele => this._dom.btn = ele,
			className: `${className}${press ? ' active' : ''}${disable ? ' disable' : ''}`,
			styles,
			...!disable && { onClick: evt => press ? null : this.setState({ press: true }) },
		}}>
			{children}
			<i {...{
				className: `fa${press ? '' : 'l'} fa-${press ? 'caret' : 'angle'}-down`,
				style: { marginLeft: 5 },
			}} />
			{press && !disable ? <ContextMenu {...{
				stick: this._dom.btn,
				stickAlign: align === 'left' ? -1 : 1,
				pointer,
				...align === 'left' ? { pointerStyle: { left: 5 } } : null,
				...align === 'right' ? { pointerStyle: { right: 5, left: 'unset' } } : null,
				stickOffset: {
					...pointer ? { y: 3 } : null,
					...align === 'right' ? { x: 3 } : null,
				},
				close: () => this.setState({ press: false }),
			}}>
				<ul>{buttons.map(b => b.auth !== false && <li {...{
					key: b.label,
					onClick: evt => this.setState({ press: false }, b.onClick),
				}}>{b.label}</li>)}</ul>
			</ContextMenu> : null}
		</DOMInst>;
	}
}

class TipButton extends TipBinder{
	static version = '1.0.0';
	static defaultProps = {
		... TipBinder.defaultProps,
		event: 'hover',
		tipProps: {
			stickDirection: 'top',
		}
	};
}

class TipIco extends TipBinder{
	static version = '1.0.0';
	static propTypes = {
		tip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
		weight: PropTypes.bool,
		disable: PropTypes.bool,
	};
	static defaultProps = {
		weight: true,
		disable: false,
	};

	render(){
		const {ico, weight, disable, className, style, onClick} = this.props;

		const _renderIco = () => <i {...{
			className: (() => {
				let css = `tipIco fa${weight ? '' : 'l'} fa-${ico}`;
				css += className ? ` ${className}` : '';
				css += disable ? ' disable' : '';
				return css;
			})(),
			style,
			... disable ? null : {onClick},
		}} />;
		return disable ? _renderIco() : <TipBinder {...{
			// tip,
			tipProps: {
				stickDirection: 'auto',
			},
			... this.props,
		}}>{_renderIco()}</TipBinder>;
	}
}

function TipSvg({ svgProps: { onClick, ...props2 }, disable, ...props }) {
	return <TipBinder disabled={disable} tipProps={{ stickDirection: 'auto' }}
		style={disable ? { opacity: .2 } : {}} {...props}>
		<img {...props2} onClick={() => disable || !onClick || onClick()} />
	</TipBinder>;
}

const ToggleButtonArrow = props => {
	return <div style={{
		borderTop: '1px solid #BBB',
		position: 'relative',
		boxShadow: '0 -5px 4px -3px rgba(3, 117, 213, 0.15)',
		marginTop: 15,
		padding: 5,
		... props.style,
	}}>
		<div className="pointer-top" style={{left: props.lefts[props.idx()]}} />
	</div>;
};

export {
	Loading,
	Switcher,
	Button, GroupButton, TipButton, TipIco, TipSvg,
	ToggleButtonArrow,
};
